module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-57x57-4fcdac7c65930da93f5df49bd9f1f979.png";